








































































































































import Vue from "vue";
import { State, Action, Getter } from "vuex-class";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const namespace: string = "RootApp";

@Component({
  components: {},
})
export default class ArchiveListComponent extends Vue {
  @Action("_appAbout", { namespace }) _appAbout: any;

  //headers = _app.archiveHeaders;
  items = [];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;
  get headers() {
    _app.archiveHeaders.map((x) => {
      x.text = this.$t(x.text);
    });
    return _app.archiveHeaders;
  }
  mounted() {
    this.$services.archive.getArchiveForPublic().then((data) => {
      if (data.Result == "OK") {
        this.items = data.Record;
      }
    });
  }
  formatDate(date: any) {
    return utils.formatDate(date);
  }
  currencyFormat(val: any, format: any) {
    return utils.formatCurrency(val, format, this.defaultLocale);
  }
}
